module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('stacked-bar-with-prior-year', {
    attrs: {
      "chart-data": _vm.chartData,
      "loading": _vm.loading,
      "chart-v-ax-format": "",
      "bus": _vm.bus
    },
    on: {
      "bar-selected": _vm.triggerBarSelect
    }
  })
},staticRenderFns: []}